import {
  ENV,
  authFetch,
  parseResponse,
  SUCCESSARRAY,
} from "../utils";

export class Classification {
  async createClassification(data) {
    const classificationData = {
      schema: data.schema,
      id: data.id?.trim().toUpperCase(),
      name: data.name?.trim(),
      description: data.description?.trim() || "",
      order: Number(data.order),
    };

    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.CLASSIFICATION.CLASSIFICATION}`;

    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(classificationData),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getClassifications(page = 1, limit = 10, filters = {}) {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...filters,
    });

    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.CLASSIFICATION.CLASSIFICATIONS}` +
      `?${queryParams.toString()}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getClassificationsByScheme(schemeCode) {
    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.CLASSIFICATION.CLASSIFICATIONS_BY_SCHEME}/` +
      schemeCode;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getClassification(classificationId) {
    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.CLASSIFICATION.CLASSIFICATION}/` +
      classificationId;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async updateClassification(classificationId, data) {
    const classificationData = {
      schema: data.schema,
      id: data.id?.trim().toUpperCase(),
      name: data.name?.trim(),
      description: data.description?.trim() || "",
      order: Number(data.order),
    };

    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.CLASSIFICATION.CLASSIFICATION}/` +
      classificationId;

    const params = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(classificationData),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async deleteClassification(classificationId) {
    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.CLASSIFICATION.CLASSIFICATION}/` +
      classificationId;

    const params = {
      method: "DELETE",
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }
}